import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
  } from "@mui/material";
  import React from "react";
  import { GlassMagnifier } from "react-image-magnifiers";
  
  const FabricInventoryImage = ({ open, onClose, rowData }) => {
    // console.log(rowData, "dddddddddd");
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle sx={{ fontWeight: "700" }}>
          {rowData?.imgName}
        </DialogTitle>
        <DialogContent>
            <>
              <GlassMagnifier
                style={{height:"100%",width:"100%"}}
                magnifierSize={300}
                imageSrc={rowData?.imgUrl}
                // largeImageSrc="./large-image.jpg" // Optional
              />
            </>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default FabricInventoryImage;
  